import { createModel } from '@rematch/core';
import { IsFixedRowHeight, ThemeMap } from 'constants/common';

export default createModel()({
  state: {
    localTheme: localStorage.getItem('localTheme') || ThemeMap.Light,
    isFixedRowHeight: localStorage.getItem('isFixedRowHeight') || IsFixedRowHeight.Auto,
  },
  reducers: {
    setState: (state: any, payload: any) => ({ ...state, ...payload }),
  },
  effects: {
    setReduxData({ key, data }) {
      this.setState({
        [key]: data,
      });
    },
  },
});
